export const SET_WEB3 = "WEB3://SET_WEB3";
export const CONNECT_WEB3 = "WEB3://CONNECT_WEB3";
export const SET_PROVIDER = "WEB3://SET_PROVIDER";
export const SET_CHAIN = "WEB3://SET_CHAIN";
